
const MOBILE_BREAKPOINT = 724

enum Breakpoints {
	MOBILE = '724px',
}

export { MOBILE_BREAKPOINT }

export default Breakpoints